export const parseTSV = (tsvData) => {
  const rows = tsvData.trim().split("\n") // Split the data into rows
  const headers = rows[0].split("\t") // Get headers from the first row

  // Map each row to an object using headers as keys
  const jsonData = rows.slice(1).map((row) => {
    const values = row.split("\t")
    return headers.reduce((obj, header, index) => {
      obj[header] = values[index] || null // Set to null if empty
      return obj
    }, {})
  })

  return jsonData
}
